import { connect } from 'react-redux';
import DriftView from './DriftView.jsx';
import { fetchIntegrations } from "src/legacy/redux/actions/integrations.jsx";
import { getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'drift');
  return {
    'integration': integration,
    integrations: state.legacyRootReducer.settings.integrations,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    }
  }
}

const DriftPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(DriftView);

export default withUseHooks(DriftPage);
